import React from 'react';

import styles from './number-input.module.scss';

export const NumberInput: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = (props) => (
  <input className={styles.input} type="number" {...props} />
);
